<p-sidebar [(visible)]="visible"
		   position="right"
		   [modal]="true"
		   [dismissible]="false"
		   [showCloseIcon]="false"
		   [closeOnEscape]="false"
		   [style]="routeDrawerPanelStyle"
		   [ngClass]="{ 'crc-route-drawer--view': viewMode || editMode }"
		   styleClass="crc-route-drawer">
	<ng-template pTemplate="header">
		<ng-container *ngIf="(viewMode || editMode) && !loadingEdit; else drawerStandardHeader">
			<div class="crc-route-view crc-route-view--sidebar-header">
				<div class="crc-route-view__hero crc-route-view__hero--sidebar-header">
					<div class="crc-route-view__hero-top">
						<span class="crc-route-view__eyebrow">Route</span>
						<span class="crc-route-view__status-pill"
							  [ngClass]="'crc-route-view__status-pill--' + routeStatusPillModifier()">{{ routeStatusLabel }}</span>
					</div>
					<h2 class="crc-route-view__name">{{ routeName }}</h2>
					<p class="crc-route-view__meta">{{ viewSubtitle }}</p>
				</div>
			</div>
			<button pButton
					type="button"
					icon="pi pi-times"
					class="p-button-text p-button-rounded crc-route-drawer__close-btn"
					(click)="guardedClose()"></button>
		</ng-container>
		<ng-template #drawerStandardHeader>
			<div class="crc-route-drawer__title">
				<span *ngIf="viewMode">View Route</span>
				<span *ngIf="!viewMode && editMode">Edit Route</span>
				<span *ngIf="!viewMode && !editMode">Create Route</span>
			</div>
			<button pButton
					type="button"
					icon="pi pi-times"
					class="p-button-text p-button-rounded crc-route-drawer__close-btn"
					(click)="guardedClose()"></button>
		</ng-template>
	</ng-template>

	<div class="crc-route-drawer__body"
		 [ngClass]="{ 'crc-route-drawer__body--view': viewMode }"
		 *ngIf="!loadingEdit; else drawerLoading">
		<ng-container *ngIf="viewMode">
			<div class="crc-route-view">
				<div class="crc-route-view__stats">
					<div class="crc-route-view__stat-card">
						<div class="crc-route-view__stat-value">{{ viewFareRangeText }}</div>
						<div class="crc-route-view__stat-label">Fare Range</div>
					</div>
					<div class="crc-route-view__stat-card">
						<div class="crc-route-view__stat-value">{{ viewTotalInventory }} Vehicles</div>
						<div class="crc-route-view__stat-label">Inventory</div>
					</div>
					<div class="crc-route-view__stat-card">
						<div class="crc-route-view__stat-value">{{ viewBookingWindowText }}</div>
						<div class="crc-route-view__stat-label">Booking Window</div>
					</div>
				</div>

				<hr class="crc-route-view__rule" />

				<h3 class="crc-route-view__section-title">Pickup Zones</h3>
				<div class="crc-route-view__chips">
					<div class="crc-route-view__chip crc-route-view__chip--pickup"
						 *ngFor="let zid of pickupZoneIds">
						<i class="pi pi-map-marker crc-route-view__chip-icon crc-route-view__chip-icon--pickup"></i>
						<span>{{ zoneName(zid) }}</span>
					</div>
				</div>

				<h3 class="crc-route-view__section-title">Drop-Off Zones</h3>
				<div class="crc-route-view__chips">
					<div class="crc-route-view__chip crc-route-view__chip--dropoff"
						 *ngFor="let zid of dropoffZoneIds">
						<i class="pi pi-flag crc-route-view__chip-icon crc-route-view__chip-icon--dropoff"></i>
						<span>{{ zoneName(zid) }}</span>
					</div>
				</div>

				<hr class="crc-route-view__rule" />

				<h3 class="crc-route-view__section-title crc-route-view__section-title--inline">
					<span>Departure slots</span>
					<span class="crc-route-view__slot-count-sep">•</span>
					<span class="crc-route-view__slot-count-num">{{ slots.length }}</span>
				</h3>

				<div class="crc-route-view__slot-list">
					<div class="crc-route-view__slot-shell"
						 *ngFor="let slot of slots">
						<div class="crc-route-view__slot-top">
							<div class="crc-route-view__slot-head-text">
								<div class="crc-route-view__slot-time">{{ formatSlotTime12h(slot.DepartureTime) }}</div>
								<div class="crc-route-view__slot-direction">{{ slotDirectionLine(slot) }}</div>
							</div>
							<p-tag [value]="slot.SlotEnabled ? 'Enabled' : 'Disabled'"
								   [rounded]="true"
								   [severity]="slot.SlotEnabled ? 'success' : 'danger'"
								   styleClass="crc-route-view__slot-status-tag"></p-tag>
						</div>

						<div class="crc-route-view__slot-metrics-wrap">
							<div class="crc-route-view__slot-metrics-row">
								<div class="crc-route-view__metric crc-route-view__metric--raised">
									<div class="crc-route-view__metric-value">{{ fmtPesoAmount(slot.FareAmount) }}</div>
									<div class="crc-route-view__metric-label">Fare</div>
								</div>
								<div class="crc-route-view__metric crc-route-view__metric--raised">
									<div class="crc-route-view__metric-value">{{ fmtPesoAmount(slot.TollAmount) }}</div>
									<div class="crc-route-view__metric-label">Toll (incl.)</div>
								</div>
								<div class="crc-route-view__metric crc-route-view__metric--raised">
									<div class="crc-route-view__metric-value">{{ inventoryCarsLabel(slot) }}</div>
									<div class="crc-route-view__metric-label">Inventory</div>
								</div>
							</div>
							<div class="crc-route-view__slot-metrics-row crc-route-view__slot-metrics-row--pair">
								<div class="crc-route-view__metric crc-route-view__metric--raised">
									<div class="crc-route-view__metric-value">{{ formatBookingWindowLabel(slot.BookingWindowMinutes ?? 0) }}</div>
									<div class="crc-route-view__metric-label">Booking window</div>
								</div>
								<div class="crc-route-view__metric crc-route-view__metric--raised">
									<div class="crc-route-view__metric-value">{{ fmtPesoAmount(slot.PremiumFareAmount) }}</div>
									<div class="crc-route-view__metric-label">Walk-in premium</div>
								</div>
							</div>
						</div>

						<hr class="crc-route-view__slot-divider" />

						<div class="crc-route-view__drivers-toolbar">
							<div class="crc-route-view__drivers-title">
								<span class="crc-route-view__drivers-title-main">Assigned Drivers</span>
								<span class="crc-route-view__drivers-title-sep">•</span>
								<span class="crc-route-view__drivers-title-count">{{ slot.assignedDrivers.length }}</span>
							</div>
							<button pButton
									type="button"
									icon="pi pi-users"
									label="Manage Assigned Driver"
									class="p-button-outlined p-button-sm crc-route-view__manage-drivers-btn"
									disabled
									title="Driver assignment is not available in this version."></button>
						</div>
						<div class="crc-route-view__driver-chips"
							 *ngIf="slot.assignedDrivers.length">
							<span class="crc-route-view__driver-chip"
								  *ngFor="let d of slot.assignedDrivers">
								<i class="pi pi-user crc-route-view__driver-chip-icon"></i>
								{{ d.displayName }}
							</span>
						</div>
						<p class="crc-route-view__drivers-empty"
						   *ngIf="!slot.assignedDrivers.length">No drivers assigned.</p>
					</div>
				</div>

				<hr class="crc-route-view__rule" />

				<section class="crc-route-view__audit">
					<h3 class="crc-route-view__section-title">Audit</h3>
					<div class="crc-route-view__audit-list">
						<div class="crc-route-view__audit-row">
							<div class="crc-route-view__audit-label">Last updated</div>
							<div class="crc-route-view__audit-value">{{ viewLastUpdatedText }}</div>
						</div>
						<div class="crc-route-view__audit-row">
							<div class="crc-route-view__audit-label">Updated by</div>
							<div class="crc-route-view__audit-value">{{ viewUpdatedByText }}</div>
						</div>
						<div class="crc-route-view__audit-row">
							<div class="crc-route-view__audit-label">Route ID</div>
							<div class="crc-route-view__audit-value">{{ viewRouteIdText() }}</div>
						</div>
					</div>
				</section>
			</div>
		</ng-container>

		<ng-container *ngIf="!viewMode">
			<section class="crc-route-drawer__section">
				<div class="crc-route-drawer__section-head">
					<span class="crc-route-drawer__step-num">1</span>
					<div>
						<h2 class="crc-route-drawer__section-title">Route details</h2>
						<p class="crc-route-drawer__section-desc">
							Name and status control where this route shows up. Direction is configured per departure slot.
						</p>
					</div>
				</div>
				<div class="crc-route-drawer__field">
					<label class="crc-route-drawer__label">Route Name</label>
					<input type="text"
						   pInputText
						   class="w-full"
						   placeholder="e.g., Clark → Manila"
						   [(ngModel)]="routeName" />
				</div>
				<div class="crc-route-drawer__status-card">
					<div class="crc-route-drawer__status-texts">
						<div class="crc-route-drawer__status-title">Route status</div>
						<div class="crc-route-drawer__status-sub">Customers can see and book this route in the app.</div>
					</div>
					<p-inputSwitch [(ngModel)]="routeCustomersCanBook"></p-inputSwitch>
				</div>
			</section>

			<section class="crc-route-drawer__section">
				<div class="crc-route-drawer__section-head">
					<span class="crc-route-drawer__step-num">2</span>
					<div>
						<h2 class="crc-route-drawer__section-title">Pickup &amp; drop-off zones</h2>
						<p class="crc-route-drawer__section-desc">Select the served boarding and alighting points for this route.</p>
					</div>
				</div>
				<div class="crc-route-drawer__field">
					<label class="crc-route-drawer__label">Pickup zone<span class="crc-route-drawer__req">*</span></label>
					<p-multiSelect [options]="zoneOptions"
								   [(ngModel)]="pickupZoneIds"
								   optionLabel="Name"
								   optionValue="Id"
								   placeholder="Add Pickup zone"
								   display="chip"
								   appendTo="body"
								   styleClass="w-full crc-route-drawer__multi"></p-multiSelect>
					<p class="crc-route-drawer__hint">Customers will see these as boarding options.</p>
				</div>
				<div class="crc-route-drawer__field">
					<label class="crc-route-drawer__label">Drop-off zone<span class="crc-route-drawer__req">*</span></label>
					<p-multiSelect [options]="zoneOptions"
								   [(ngModel)]="dropoffZoneIds"
								   optionLabel="Name"
								   optionValue="Id"
								   placeholder="Add drop-off zone"
								   display="chip"
								   appendTo="body"
								   styleClass="w-full crc-route-drawer__multi"></p-multiSelect>
					<p class="crc-route-drawer__hint">Each zone supports a name, optional description, and geofence.</p>
				</div>
			</section>

			<section class="crc-route-drawer__section crc-route-drawer__section--slots">
				<div class="crc-route-drawer__section-head crc-route-drawer__section-head--row">
					<div class="crc-route-drawer__section-head-main">
						<span class="crc-route-drawer__step-num">3</span>
						<div>
							<h2 class="crc-route-drawer__section-title">Departure slots</h2>
							<p class="crc-route-drawer__section-desc">
								One route can have multiple slots. Each slot has its own fare, toll, and inventory.
							</p>
						</div>
					</div>
					<button pButton
							type="button"
							label="Add Slot"
							icon="pi pi-plus"
							class="crc-route-drawer__add-slot"
							(click)="addSlot()"></button>
				</div>

				<div class="crc-route-drawer__slot-list">
					<div class="crc-route-drawer__slot"
						 *ngFor="let slot of slots; let si = index">
						<div class="crc-route-drawer__slot-head"
							 (click)="toggleSlot(si)">
							<div class="crc-route-drawer__slot-head-text">
								<div class="crc-route-drawer__slot-line1">{{ slotHeaderPrimary(slot) }}</div>
								<div class="crc-route-drawer__slot-line2">{{ slotHeaderSecondary(slot) }}</div>
							</div>
							<div class="crc-route-drawer__slot-head-actions">
								<button pButton
										type="button"
										icon="pi pi-copy"
										class="p-button-text p-button-rounded p-button-sm"
										(click)="duplicateSlot(si); $event.stopPropagation()"></button>
								<button pButton
										*ngIf="!editMode"
										type="button"
										icon="pi pi-trash"
										class="p-button-text p-button-rounded p-button-sm"
										(click)="removeSlot(si); $event.stopPropagation()"></button>
								<i class="pi"
								   [ngClass]="slot.expanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
							</div>
						</div>
						<div class="crc-route-drawer__slot-body"
							 *ngIf="slot.expanded">
							<div class="crc-route-drawer__grid2">
								<div class="crc-route-drawer__field">
									<label class="crc-route-drawer__label">Pickup zone<span class="crc-route-drawer__req">*</span></label>
									<p-dropdown [options]="pickupDropdownOptions"
												[(ngModel)]="slot.PickupZoneId"
												optionLabel="Name"
												optionValue="Id"
												placeholder="Select Pickup zone"
												[filter]="true"
												appendTo="body"
												styleClass="w-full"></p-dropdown>
								</div>
								<div class="crc-route-drawer__field">
									<label class="crc-route-drawer__label">To zone<span class="crc-route-drawer__req">*</span></label>
									<p-dropdown [options]="dropoffDropdownOptions"
												[(ngModel)]="slot.DropoffZoneId"
												optionLabel="Name"
												optionValue="Id"
												placeholder="Select drop-off zone"
												[filter]="true"
												appendTo="body"
												styleClass="w-full"></p-dropdown>
								</div>
							</div>
							<div class="crc-route-drawer__field">
								<label class="crc-route-drawer__label">Departure Time<span class="crc-route-drawer__req">*</span></label>
								<input type="time"
									   class="crc-route-drawer__time"
									   [(ngModel)]="slot.DepartureTime" />
							</div>
							<div class="crc-route-drawer__grid2">
								<div class="crc-route-drawer__field">
									<label class="crc-route-drawer__label">Fare per slot<span class="crc-route-drawer__req">*</span></label>
									<p-inputNumber [(ngModel)]="slot.FareAmount"
												   mode="currency"
												   currency="PHP"
												   locale="en-PH"
												   [minFractionDigits]="0"
												   [maxFractionDigits]="2"
												   styleClass="w-full"></p-inputNumber>
									<p class="crc-route-drawer__hint">Per-vehicle fare paid by the customer.</p>
								</div>
								<div class="crc-route-drawer__field">
									<label class="crc-route-drawer__label">Toll amount</label>
									<p-inputNumber [(ngModel)]="slot.TollAmount"
												   mode="currency"
												   currency="PHP"
												   locale="en-PH"
												   [minFractionDigits]="0"
												   [maxFractionDigits]="2"
												   styleClass="w-full"></p-inputNumber>
									<p class="crc-route-drawer__hint">{{ tollHint(slot) }}</p>
								</div>
							</div>
							<div class="crc-route-drawer__grid2">
								<div class="crc-route-drawer__field">
									<label class="crc-route-drawer__label">Vehicle Inventory<span class="crc-route-drawer__req">*</span></label>
									<p-inputNumber [(ngModel)]="slot.VehicleCapacity"
												   [min]="0"
												   [useGrouping]="false"
												   styleClass="w-full"></p-inputNumber>
									<p class="crc-route-drawer__hint">
										Deducted as customers book. Shows &quot;All cars are booked&quot; at 0.
									</p>
								</div>
								<div class="crc-route-drawer__field">
									<label class="crc-route-drawer__label">Min. advance booking window<span class="crc-route-drawer__req">*</span></label>
									<p-inputNumber [(ngModel)]="slot.BookingWindowMinutes"
												   [min]="0"
												   [useGrouping]="false"
												   suffix=" min"
												   styleClass="w-full"></p-inputNumber>
									<p class="crc-route-drawer__hint">Earliest a customer can book before departure.</p>
								</div>
							</div>
							<div class="crc-route-drawer__field">
								<label class="crc-route-drawer__label">Walk-in Premium Fare</label>
								<p-inputNumber [(ngModel)]="slot.PremiumFareAmount"
											   mode="currency"
											   currency="PHP"
											   locale="en-PH"
											   [minFractionDigits]="0"
											   [maxFractionDigits]="2"
											   styleClass="w-full"></p-inputNumber>
								<p class="crc-route-drawer__hint">
									Additional amount applied for walk-in bookings made via Ops/Admin tool.
								</p>
							</div>
							<div class="crc-route-drawer__status-card crc-route-drawer__status-card--slot">
								<div class="crc-route-drawer__status-texts">
									<div class="crc-route-drawer__status-title">Slot status</div>
									<div class="crc-route-drawer__status-sub">Disabled slots are hidden from customers.</div>
								</div>
								<p-inputSwitch [(ngModel)]="slot.SlotEnabled"></p-inputSwitch>
							</div>
						</div>
					</div>
				</div>
			</section>
		</ng-container>
	</div>

	<ng-template #drawerLoading>
		<div class="crc-route-drawer__loading">
			<p-progressSpinner strokeWidth="4"
							   animationDuration=".8s"></p-progressSpinner>
		</div>
	</ng-template>

	<ng-template pTemplate="footer">
		<div class="crc-route-view__footer"
			 *ngIf="viewMode">
			<div class="crc-route-view__footer-start">
				<button pButton
						*ngIf="canUpdateRoute && viewFooterShowsEnableRoute"
						type="button"
						label="Enable Route"
						class="crc-route-drawer__btn-primary crc-route-drawer__btn-enable-route"
						[disabled]="saving"
						(click)="onEnableRouteFromView()"></button>
				<button pButton
						*ngIf="canUpdateRoute && viewFooterShowsDisableRoute"
						type="button"
						label="Disable Route"
						class="p-button-outlined p-button-danger crc-route-drawer__btn-disable-route"
						[disabled]="saving"
						(click)="openDisableRouteDialog()"></button>
			</div>
			<button pButton
					*ngIf="canUpdateRoute"
					type="button"
					label="Edit Route"
					icon="pi pi-pencil"
					class="crc-route-drawer__btn-primary crc-route-view__footer-edit"
					[disabled]="saving"
					(click)="startEditFromView()"></button>
		</div>
		<div class="crc-route-drawer__footer"
			 *ngIf="!viewMode">
			<button pButton
					type="button"
					label="Cancel"
					class="p-button-text crc-route-drawer__btn-cancel"
					(click)="guardedClose()"></button>
			<div class="crc-route-drawer__footer-right">
				<button pButton
						*ngIf="!editMode"
						type="button"
						label="Save as Draft"
						class="p-button-outlined crc-route-drawer__btn-draft"
						[disabled]="saving"
						(click)="save(true)"></button>
				<button pButton
						type="button"
						[label]="editMode ? 'Save and Update' : 'Create Route'"
						class="crc-route-drawer__btn-primary"
						[disabled]="saving"
						(click)="save(false)"></button>
			</div>
		</div>
	</ng-template>
</p-sidebar>

<p-dialog [(visible)]="disableRouteDialogVisible"
		  [modal]="true"
		  [showHeader]="false"
		  [closable]="false"
		  [draggable]="false"
		  [resizable]="false"
		  [appendTo]="'body'"
		  [dismissableMask]="true"
		  [style]="{ width: 'min(648px, calc(100vw - 32px))' }"
		  styleClass="crc-connex-route-dialog"
		  (onHide)="closeDisableRouteDialog()">
	<div class="crc-connex-route-dialog__panel">
		<div class="crc-connex-route-dialog__header">
			<img src="../Content/xpress-app/images/error-red-exclamation.svg"
				 width="24"
				 height="24"
				 alt="" />
			<h2 class="crc-connex-route-dialog__title">Disable Route?</h2>
		</div>
		<div class="crc-connex-route-dialog__content">
			<p class="crc-connex-route-dialog__lead">
				Are you sure you want to disable this route? This will affect all associated departure slots and booking availability.
			</p>
			<ul class="crc-connex-route-dialog__list">
				<li>
					<span class="crc-connex-route-dialog__li-title">App Visibility:</span>
					{{ disableConfirmAppVisibilityDetail() }}
				</li>
				<li>
					<span class="crc-connex-route-dialog__li-title">Booking Impact:</span>
					{{ disableConfirmBookingImpactDetail() }}
				</li>
			</ul>
		</div>
		<div class="crc-connex-route-dialog__footer">
			<button pButton
					type="button"
					label="Cancel"
					class="p-button-outlined crc-connex-route-dialog__btn-cancel"
					[disabled]="saving"
					(click)="closeDisableRouteDialog()"></button>
			<button pButton
					type="button"
					label="Yes, Disable Route"
					class="crc-connex-route-dialog__btn-confirm"
					[disabled]="saving"
					(click)="confirmDisableRouteInDialog()"></button>
		</div>
	</div>
</p-dialog>

<p-dialog [(visible)]="showDiscardDialog"
		  [modal]="true"
		  [showHeader]="false"
		  [closable]="false"
		  [draggable]="false"
		  [resizable]="false"
		  [appendTo]="'body'"
		  [dismissableMask]="true"
		  [style]="{ width: 'min(648px, calc(100vw - 32px))' }"
		  styleClass="crc-connex-route-dialog"
		  (onHide)="keepEditing()">
	<div class="crc-connex-route-dialog__panel">
		<div class="crc-connex-route-dialog__header">
			<img src="../Content/xpress-app/images/error-red-exclamation.svg"
				 width="24"
				 height="24"
				 alt="" />
			<h2 class="crc-connex-route-dialog__title">Discard changes?</h2>
		</div>	
		<div class="crc-discard-dialog__content">
			<p class="crc-discard-dialog__lead">
				You have unsaved changes in this ConneX route. If you leave now, your updates will not be saved.
			</p>
		</div>
		<div class="crc-connex-route-dialog__footer">
			<button pButton
					type="button"
					label="Keep editing"
					class="p-button-outlined crc-connex-route-dialog__btn-cancel"
					[disabled]="saving"
					(click)="keepEditing()"></button>
			<button pButton
					type="button"
					label="Discard changes"
					class="crc-connex-route-dialog__btn-confirm"
					[disabled]="saving"
					(click)="discardChanges()"></button>
		</div>
	</div>
</p-dialog>
